
import { Component, Input, OnInit } from '@angular/core';
import { Yii } from 'libraries/interfaces/Yii';
import { IExternalBooking, TGetBookingResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { BookingService } from 'libraries/service/booking/booking.service';
import { Observable, forkJoin, of as observableOf } from 'rxjs';
import { map } from 'rxjs/operators';

interface IStatusesCodes {
    midOffice: string;
    issuance: string;
}

@Component({
    selector: 'booking-statuses',
    template: `
        <booking-status mode="label" [status]="bookingData.xStatus"></booking-status>
        <div *ngIf="statusesStream | async as statuses">
            <em *ngIf="statuses.midOffice !== null">
                ({{ labels.internal }}) <strong [class]="midOfficeData.xStatus">{{ statuses.midOffice }}</strong>
            </em>
            <em *ngIf="statuses.issuance !== null">
                ({{ labels.issuance }}) <strong [class]="bookingData.issueStatus">{{ statuses.issuance }}</strong>
            </em>
        </div>
    `,
    styles: [`
        strong{
            color: #31708f;
        }
        strong.confirm,
        strong.completelyIssued
        {
            color: #3c763d;
        }
        strong.cancel{
            color: #707070;
        }
        strong.partiallyIssued{
            color: #ff9100;
        }
        strong.actionRequired,
        strong.notIssued{
            color: #a94442;
        }
        em{
            display: block;
            font-size: .8rem;
            margin-top: .2rem;
        }
    `]
})

export class BookingStatusesComponent implements OnInit {

    public statusesStream: Observable<IStatusesCodes>;

    public labels: { [key: string]: string } = {
        host: Yii.t('wui-shared-js', 'source'),
        internal: Yii.t('wui-shared-js', 'interne'),
        issuance: Yii.t('wui-shared-js', 'émission'),
    };

    public get midOfficeData(): IExternalBooking {
        if (this.bookingData.externalBooking) {
            return this.bookingData.externalBooking.find(
                (externalBooking: IExternalBooking) => externalBooking.origin === 'agency'
            );
        }
        return null;
    }

    private get midOfficeStatusStream(): Observable<string> {
        const midOfficeData: IExternalBooking = this.midOfficeData;
        return midOfficeData ? this.bookingService.getMidOfficeLabel(midOfficeData.xStatus) : observableOf(null);
    }

    private get issueStatusStream(): Observable<string> {
        return this.bookingData.issueStatus ? this.bookingService.getIssueStatusLabel(this.bookingData.issueStatus) : observableOf(null);
    }


    @Input()
    public bookingData: TGetBookingResponse;

    constructor(
        private readonly bookingService: BookingService
    ) { }

    public ngOnInit(): void {
        this.statusesStream = forkJoin(this.midOfficeStatusStream, this.issueStatusStream)
            .pipe(
                map(([midOffice, issuance]: [string, string]) => ({
                    midOffice,
                    issuance
                }))
            );
    }
}